import React from "react";
import MonitorHeartRoundedIcon from '@mui/icons-material/MonitorHeartRounded';
import MonitorWeightRoundedIcon from '@mui/icons-material/MonitorWeightRounded';
import HearingRoundedIcon from '@mui/icons-material/HearingRounded';
import BloodtypeRoundedIcon from '@mui/icons-material/BloodtypeRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import {DeviceType} from "../utils/deviceInfo";

// 기기 분류별 아이콘
const DeviceTypeIcon = (props: { type: DeviceType, color?: string, size?: number }) => {
  const iconStyle = { color: props.color || '#59b544', fontSize: props.size || 26 };

  if (props.type === 'pressure') return <MonitorHeartRoundedIcon sx={iconStyle} />;
  if (props.type === 'weight') return <MonitorWeightRoundedIcon sx={iconStyle} />;
  if (props.type === 'stethoscope') return <HearingRoundedIcon sx={iconStyle} />;
  if (props.type === 'blood') return <BloodtypeRoundedIcon sx={iconStyle} />;
  return <FavoriteRoundedIcon sx={iconStyle} />;
}

export default DeviceTypeIcon;
